import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/outsourced-qa")({
  beforeLoad: () => { throw redirect({ to: "/zh-cn/services/quality-assurance/qa-support-outsourcing", statusCode: 301 }); },
});
